import React, { useCallback, useMemo, useContext } from 'react'
import { Button } from 'react-bootstrap';
import styles from './SingleManagerFile.module.css'
import FileViewer from 'react-file-viewer';
import noImage from '../../../assets/no-image.png'
import { useTranslation } from "react-i18next";
import { formatDateFromDB } from '../../../util/functions'
import fileTypeExcel from '../../../assets/file-types/file-type-excel.png'
import fileTypePdf from '../../../assets/file-types/file-type-pdf.png'
import fileTypePowerPoint from '../../../assets/file-types/file-type-powerpoint.png'
import fileTypeTxt from '../../../assets/file-types/file-type-txt.png'
import fileTypeWord from '../../../assets/file-types/file-type-word.png'
import * as fileReq from '../../../axios/requests/filesReq'
import { ConfirmationModalContext } from '../../../context/ConfirmationModalContext/ConfirmationModalContext'
import AlertContext from '../../../context/AlertModelContext/AlertModalContext';

const SingleManagerFile = React.memo((props) => {
    const { fileUrl, fileType, createdAt, fileName, onSelectClicked, onPreviewClicked, isFileSelected, id, isPreviewSelected, onDeleteFile, permissionType, onClickAttachFile,previewUrl } = props
    const { showModal: showConfirmationModal } = useContext(ConfirmationModalContext);
    const alertCtx = useContext(AlertContext)
    const [t] = useTranslation('common');
    let SingleFileContainer
    let iconString

    // switch (fileType) {
    //     case 'jpeg':
    //         SingleFileContainer = <img className={styles['image-file']} src={fileUrl} alt={fileName} onError={(event) => { event.target.onerror = null; event.target.src = noImage }} />
    //         break;
    //     default:
    //         SingleFileContainer = <FileViewer
    //             fileType={fileType}
    //             filePath={fileUrl}
    //             onError={onError}
    //         />
    // }

    const staticFileUrl = useMemo(() => {
        return fileUrl
    }, [])

    const onSelectHandler = useCallback((event) => {
        event.stopPropagation()
        onSelectClicked(id)
    }, [id, onSelectClicked])

    const onAttachClickHandler = useCallback((event) => {
        event.stopPropagation()
        onClickAttachFile(id)
    }, [id, onSelectClicked])

    const onPreviewHandler = useCallback((event) => {
        event.stopPropagation()
        if (fileType === 'signature') {
            window.open(previewUrl, "_blank")
        }
        else {
            onPreviewClicked(id)
        }
    }, [id, onPreviewClicked])

    const onError = useCallback((e) => {
        console.log('Error in file-viewer', e);
    }, []);

    const getImageElementBySource = useCallback(
        (src) => <img className={styles['image-file']} src={src} alt={fileName} onError={(event) => { event.target.onerror = null; event.target.src = noImage }} />
        , [fileName])

    switch (fileType) {//fa-solid fa-file-signature
        case 'signature':
            iconString = `fa-solid fa-file-signature ${styles['file-signature']}`
            SingleFileContainer = getImageElementBySource(staticFileUrl)
            break;
        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
            iconString = `fa-regular fa-file-image ${styles['file-image']}`
            SingleFileContainer = getImageElementBySource(staticFileUrl)
            break;
        case 'doc':
        case 'docx':
            iconString = `fa-regular fa-file-word ${styles['file-word']}`
            SingleFileContainer = getImageElementBySource(fileTypeWord)
            break;
        case 'pdf':
            iconString = `fa-regular fa-file-pdf ${styles['file-pdf']}`
            SingleFileContainer = getImageElementBySource(fileTypePdf)
            break;
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'aac':
        case 'm4a':
            iconString = `fa-regular fa-file-audio ${styles['file-audio']}`
            SingleFileContainer =
                <FileViewer
                    fileType={fileType}
                    filePath={staticFileUrl}
                    onError={onError}
                />
            break;
        case 'csv':
        case 'xls':
        case 'xlsx':
            iconString = `fa-regular fa-file-excel ${styles['file-excel']}`
            SingleFileContainer = getImageElementBySource(fileTypeExcel)
            break;
        case 'pptx':
        case 'ppt':
            iconString = `fa-regular fa-file-powerpoint ${styles['file-ppt']}`
            SingleFileContainer = getImageElementBySource(fileTypePowerPoint)
            break
        case 'txt':
            iconString = `fa-regular fa-file-lines ${styles['file-text']}`
            SingleFileContainer = getImageElementBySource(fileTypeTxt)
            break
        case 'mp4':
            iconString = `fa-regular fa-file-video ${styles['file-video']}`
            SingleFileContainer =
                <FileViewer
                    fileType={fileType}
                    filePath={staticFileUrl}
                    onError={onError}
                />
            break
        default:
            iconString = `fa-regular fa-circle-question ${styles['file-question']}`
            SingleFileContainer =
                <FileViewer
                    fileType={fileType}
                    filePath={staticFileUrl}
                    onError={onError}
                />
    }

    const deleteFileById = useCallback(async (fileId) => {
        showConfirmationModal(async () => {
            try {
                await fileReq.deleteOneFileById(fileId)
                onDeleteFile(fileId)
            }
            catch (e) {
                alertCtx.showAlert(t('fail'), t('Error to delete file', { fileName }), 'sm');
                console.log(`Error to delete file message = ${e.message}`)
            }
        },
            {
                titleKey: t('Deletion Header Modal'),
                bodyKey: t('Are you sure you want to delete this file?', { fileName }),
                customDeleteBtnName: t('Delete File')
            });

    }, [])

    return (
        <article className={`${styles['file-main']} ${isFileSelected && styles['file-main--selected']} ${isPreviewSelected}`}>
            <div className={styles['file-main-header']}>
                <div className={styles['file-main-title']}>
                    <i className={`${iconString} ${styles['file-type-icon']}`} />
                    <h3 className={styles['file-title']}>{fileName}</h3>
                </div>
                <div style={{ direction: 'ltr' }}>
                    <time className={styles['file-date']}>{formatDateFromDB(createdAt, true)}</time>
                </div>
            </div>

            <div className={`single-file-container ${styles['file-container']}`} >
                {SingleFileContainer}
            </div>
            <div className={`${styles['file-controller']}`}>
                <div className={`${styles['file-controller-btns--right']}`}>
                    {fileType !== 'signature' && <Button className={`${styles['file-controll-btn']} ${styles['file-controll-btn--gray']}`} onClick={onSelectHandler} >
                        {t('Select')}
                    </Button>}
                    <Button className={`${styles['file-controll-btn']} ${styles['file-controll-btn--gray']} ${isPreviewSelected && styles['preview-btn-selected']}`} onClick={onPreviewHandler} title={t('View')}>
                        <i class="fa-regular fa-eye" />
                    </Button>
                    <a target='_blank' href={fileUrl} download={fileName}>
                        <Button className={`${styles['file-controll-btn']} ${styles['file-controll-btn--gray']}`} title={t('download')} >
                            <i className="fa-regular fa-circle-down" />
                        </Button>
                    </a>
                    {permissionType <= 3 && onDeleteFile && <Button className={`${styles['file-controll-btn']} ${styles['file-controll-btn--gray']}`} onClick={() => deleteFileById(id)} >
                        <i class="fa-regular fa-trash-can" />
                    </Button>}
                </div>
                <Button variant="secondary" className={`${styles['file-controll-btn']} ${styles['file-controll-btn--strong-gray']}`} onClick={onAttachClickHandler}>{t('attach')}</Button>
            </div>

        </article>
    )
})

export default SingleManagerFile